module.exports = __webpack_public_path__ + "img/9788935208975.2166e05e.jpg";